export default "__VITE_ASSET__CZbG1zNn__"